module.exports = __webpack_public_path__ + "img/arrow-right.c1ecab47.svg";